type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  fillColor?: string;
};

const LongArrowDownIcon = (props: Props) => {
  const {
    width = '8',
    height = '10',
    viewBox = '0 0 8 10',
    fillColor = '#F3E9D7',
  } = props;
  
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none">
      <path d="M3.71702 9.8778L0.117216 6.12793C0.0421643 6.04974 0 5.94371 0 5.83314C0 5.72258 0.0421643 5.61654 0.117216 5.53836C0.192268 5.46018 0.294061 5.41626 0.400201 5.41626C0.506341 5.41626 0.608133 5.46018 0.683185 5.53836L3.60002 8.57732V0.416653C3.60002 0.30615 3.64216 0.200173 3.71717 0.122035C3.79218 0.0438974 3.89392 4.89645e-08 4 4.76995e-08C4.10608 4.64345e-08 4.20782 0.0438974 4.28283 0.122035C4.35784 0.200173 4.39998 0.30615 4.39998 0.416653V8.57732L7.31682 5.53836C7.39187 5.46018 7.49366 5.41626 7.5998 5.41626C7.70594 5.41626 7.80773 5.46018 7.88278 5.53836C7.95784 5.61654 8 5.72258 8 5.83314C8 5.94371 7.95784 6.04974 7.88278 6.12792L4.28298 9.8778C4.24584 9.91654 4.20172 9.94727 4.15317 9.96824C4.10461 9.98921 4.05256 10 4 10C3.94744 10 3.89539 9.98921 3.84683 9.96824C3.79828 9.94727 3.75416 9.91654 3.71702 9.8778Z" fill={fillColor}/>
    </svg>
  );
};

export default LongArrowDownIcon;
